"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _ckeditor4React = require("ckeditor4-react");
var _styles = _interopRequireDefault(require("./styles.scss"));
var _constants = _interopRequireDefault(require("./constants"));
var _reducer = _interopRequireDefault(require("./reducer"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var KEY = 'rich-text';
var CLASS_NAME = _lodash.default.get(_styles.default, KEY, KEY);

/**
 * RichTextEditor component
 */
var RichTextEditor = function RichTextEditor(props) {
  var className = props.className,
    _props$input = props.input,
    value = _props$input.value,
    onChange = _props$input.onChange,
    name = _props$input.name;
  var _useReducer = (0, _react.useReducer)(_reducer.default, {
      data: undefined
    }),
    _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
    data = _useReducer2[0].data,
    dispatch = _useReducer2[1];
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  var editorOpts = {
    element: element,
    initContent: value,
    dispatchEvent: dispatch,
    subscribeTo: ['beforeLoad', 'change'],
    config: _constants.default
  };
  var _useCKEditor = (0, _ckeditor4React.useCKEditor)(editorOpts),
    editor = _useCKEditor.editor;
  if (editor) {
    editor.on('mode', function () {
      if (editor.mode === 'source') {
        var editable = editor.editable();
        editable.attachListener(editable, 'input', function () {
          // Handle changes made in the source mode.
          onChange(editable.editor.getData());
        });
      }
    });
  }
  (0, _react.useEffect)(function () {
    if (editor && value !== data) {
      editor.setData(value);
    }
  }, [value]);
  (0, _react.useEffect)(function () {
    onChange(data);
  }, [data]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CLASS_NAME, " ").concat(className),
    name: name
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: setElement
  }));
};
RichTextEditor.propTypes = {
  className: _propTypes.default.string,
  input: _propTypes.default.shape({
    label: _propTypes.default.string,
    name: _propTypes.default.string,
    value: _propTypes.default.string,
    onChange: _propTypes.default.func.isRequired
  }).isRequired
};
RichTextEditor.defaultProps = {
  className: ''
};
var _default = RichTextEditor;
exports.default = _default;